var _g, _g2;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgCloseGe = function SvgCloseGe(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_54152",
    "data-name": "Group 54152",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_54150",
    "data-name": "Group 54150"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5329",
    "data-name": "Rectangle 5329",
    width: 3.4,
    height: 3.4,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5330",
    "data-name": "Rectangle 5330",
    width: 3.4,
    height: 3.4,
    transform: "translate(3.4 3.4)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5331",
    "data-name": "Rectangle 5331",
    width: 3.4,
    height: 3.4,
    transform: "translate(6.8 6.8)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5332",
    "data-name": "Rectangle 5332",
    width: 3.4,
    height: 3.4,
    transform: "translate(10.2 10.2)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5333",
    "data-name": "Rectangle 5333",
    width: 3.4,
    height: 3.4,
    transform: "translate(13.6 13.6)",
    fill: "#ffffff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_54151",
    "data-name": "Group 54151"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5329-2",
    "data-name": "Rectangle 5329",
    width: 3.4,
    height: 3.4,
    transform: "translate(13.6)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5330-2",
    "data-name": "Rectangle 5330",
    width: 3.4,
    height: 3.4,
    transform: "translate(10.2 3.4)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5331-2",
    "data-name": "Rectangle 5331",
    width: 3.4,
    height: 3.4,
    transform: "translate(6.8 6.8)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5332-2",
    "data-name": "Rectangle 5332",
    width: 3.4,
    height: 3.4,
    transform: "translate(3.4 10.2)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5333-2",
    "data-name": "Rectangle 5333",
    width: 3.4,
    height: 3.4,
    transform: "translate(0 13.6)",
    fill: "#ffffff"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCloseGe, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close-ge.5986d0e8.svg";
export { ForwardRef as ReactComponent };